import { render, staticRenderFns } from "./EditBasicDetailsDialog.vue?vue&type=template&id=53b199be&"
import script from "./EditBasicDetailsDialog.vue?vue&type=script&lang=js&"
export * from "./EditBasicDetailsDialog.vue?vue&type=script&lang=js&"
import style0 from "./EditBasicDetailsDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
